import {
  ADD_UPDATE_USER_FAILURE,
  ADD_UPDATE_USER_REQUEST,
  ADD_UPDATE_USER_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  RESET_ON_LOGOUT,
  SET_LOGGED_IN_USER_REQUEST,
} from "./actionTypes";
import { User } from "./types";

export const fetchUsersRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  }
) => ({
  type: FETCH_USERS_REQUEST,
  url,
  payload,
});

export const fetchUsersSuccess = (users: User[], totalCount: number) => ({
  type: FETCH_USERS_SUCCESS,
  payload: { users, totalCount },
});

export const fetchUsersFailure = (error: string) => ({
  type: FETCH_USERS_FAILURE,
  payload: error,
});

export const addUpdateUserRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_USER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateUserSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_USER_SUCCESS,
  payload: { successMessage },
});

export const addUpdateUserFailure = (error: string) => ({
  type: ADD_UPDATE_USER_FAILURE,
  payload: error,
});

export const setLoggedInUserInfo = (payload: any): any => ({
  type: SET_LOGGED_IN_USER_REQUEST,
  payload
});

export const resetOnLogout = (): any => ({
  type: RESET_ON_LOGOUT,
});
